const nav = (path) => `.sidebar a[href='${path}']`;

const common = {
  cycle: {
    target: ".cycle-select",
    title: "Choose the performance cycle",
    body: "Everything you see belongs to the cycle selected here. Switch it to look at an earlier year.",
  },
  bell: {
    target: ".bell",
    title: "Notifications",
    body: "Approvals, returned items, reminders and results arrive here. The number shows what you haven't read yet.",
  },
  views: {
    // [UPDATED] PM-19: no view switch any more; all menus are in the sidebar.
    target: ".sidebar-nav",
    title: "All your menus in one place",
    body: "You have more than one role, so the sidebar has one block per role, for example My team and My work. Click any menu to open it; a block can be folded with its title.",
  },
  profile: {
    target: ".user-chip",
    title: "Your profile and this tour",
    body: "Open this menu for your profile, to take this tour again, or to log out.",
  },
};

const done = {
  target: null,
  title: "You're ready",
  body: "That's the tour. You can take it again any time from your name at the top right → Take the tour.",
};

export const TOUR_STEPS = {
  employee: [
    {
      target: null,
      title: "Welcome to Teliolabs PMS, {name}",
      body: "This one-minute tour shows where to set your goals, track progress and see your result. Use Next, or the arrow keys.",
    },
    common.cycle,
    { target: nav("/dashboard"), title: "Dashboard", body: "Your stage in the cycle, what is due next and your progress at a glance." },
    {
      target: nav("/my-goals"),
      title: "My goals",
      body: "Add your goals with a weight and target (weights total 100%) and submit them to your manager. Later, click Update on a goal to report progress; your manager approves each update.",
    },
    {
      target: nav("/my-kra-kpi"),
      title: "My KRA & KPI",
      body: "Your KRAs and KPIs, with the KPIs grouped under each KRA. Use Add KRA / KPI to add your own; your manager approves them.",
    },
    { target: nav("/self-assessment"), title: "Self assessment", body: "At year end, rate your goals, enter KRA and KPI actuals, add evidence and submit to your manager." },
    { target: nav("/my-results"), title: "My results", body: "Your final score and rating appear here once HR releases them. Acknowledge that you have seen it." },
    { target: nav("/evidence"), title: "My evidence", body: "Every file and link you attached as proof of your work, searchable by goal, KRA or type." },
    common.bell,
    common.profile,
    done,
  ],
  manager: [
    {
      target: null,
      title: "Your manager view, {name}",
      body: "As a manager you approve your team's goals, proposals and progress, and write their assessments. Here is where each happens.",
    },
    common.views,
    { target: nav("/team"), title: "Team members", body: "Everyone who reports to you, with their stage in the cycle. Click a person to see their goals and progress." },
    { target: nav("/team/goal-approvals"), title: "Goal approvals", body: "Goal sheets waiting for you. Approve them, or request changes with a comment." },
    {
      target: nav("/team/progress-approvals"),
      title: "Progress approvals",
      body: "Every progress update waits here, even a 10% step. A goal changes only after you approve; Return sends it back with your comment.",
    },
    { target: nav("/team/kra-kpi-proposals"), title: "KRA & KPI proposals", body: "KRAs and KPIs your team suggested. Approve, return for changes, or reject." },
    { target: nav("/team/assessments"), title: "Team assessments", body: "At year end, review each self assessment, agree the achievement and send your review to HR." },
    { target: nav("/evidence"), title: "Team evidence", body: "Search the files and links your team attached as proof." },
    common.bell,
    done,
  ],
  hr: [
    {
      target: null,
      title: "Your HR view, {name}",
      body: "HR sets up people, KRAs and KPIs, runs the cycle and finalizes results. This tour shows where each task lives.",
    },
    common.views,
    {
      target: nav("/hr/employees"),
      title: "Employees",
      body: "Add people one by one or import them from Excel/CSV, invite them by email to create their login, export the employee master, and deactivate leavers.",
    },
    { target: nav("/hr/organisation"), title: "Organisation setup", body: "Departments, designations and company settings." },
    { target: nav("/hr/cycles"), title: "Performance cycles", body: "Create a cycle with its stage dates, add employees and launch it. Switch on manager approval for progress updates here." },
    {
      target: nav("/hr/kra-kpi"),
      // [UPDATED] PM-15/PM-16: HR reviews and edits; employees add their own KRAs and KPIs.
      title: "KRA, KPI & goal review",
      body: "See every employee's KRAs, KPIs and goals and correct them when needed. Employees add their own and managers approve them; HR does not assign.",
    },
    { target: nav("/hr/rating-settings"), title: "Scoring & ratings", body: "The scoring weights and rating bands each cycle uses." },
    { target: nav("/hr/review"), title: "Review & finalise", body: "Manager-reviewed appraisals arrive here. Check the score, finalize, and release the result." },
    { target: nav("/reports"), title: "Reports", body: "Organisation reports with Excel export." },
    common.bell,
    done,
  ],
  management: [
    {
      target: null,
      title: "Your management view, {name}",
      body: "A read-only summary of performance across the organisation.",
    },
    common.views,
    { target: nav("/dashboard"), title: "Leadership summary", body: "Active employees, average score, rating distribution and cycle completion." },
    { target: nav("/reports"), title: "Reports", body: "Detailed reports by department and rating, with Excel export." },
    done,
  ],
  admin: [
    {
      target: null,
      title: "Your admin view, {name}",
      body: "Administrators manage logins, roles and the system settings.",
    },
    common.views,
    { target: nav("/admin/users"), title: "Users & roles", body: "Give people their roles, invite them by email or set a temporary password, reset passwords and block logins." },
    { target: nav("/hr/rating-settings"), title: "Scoring & ratings", body: "The scoring weights and rating bands each cycle uses." },
    { target: nav("/hr/cycles"), title: "Performance cycles", body: "Create and launch cycles, like HR." },
    done,
  ],
};